module.exports = __webpack_public_path__ + "img/vg.ec98f3c1.svg";